@let activeTabIndex = routerSelectors.tabIndex | select;
@let currentRouterParams = routerSelectors.params | select:{};

<nav mat-tab-nav-bar [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
  @for (tab of tabs; track tab.index) {
    @if (isDisabled(tab)) {
      <a mat-tab-link [disabled]="true">{{ tab.label }}</a>
    } @else {
      <a mat-tab-link class="px-pf-nav-tab-{{tab.index}}"
         [active]="activeTabIndex === tab.index"
         [pxNamedRouterLink]="tab.routeName"
         [pxNamedRouterLinkParams]="currentRouterParams"
         [pxQueryParams]="queryParamsSelectors.cachedParamsFor(tab.routeName) | select"
         (click)="onClick(tab)">
        {{ tab.label }}
      </a>
    }
  }
</nav>

<!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- We need to allow this to be calculated on init. -->
<div class="relative w-full overflow-hidden" [style.min-height.rem]="minHeightRem">
  <mat-tab-nav-panel #tabPanel [@ROUTER_TAB_GROUP_TRANSITIONS]="activeTabIndex" class="block w-full overflow-hidden">
    <router-outlet/>
  </mat-tab-nav-panel>
</div>
